import { Component, Inject } from '@angular/core';
import { FormService } from "../../services/form.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from "@angular/forms";

@Component({
	selector: 'app-consent-movers-modal',
	templateUrl: './consent-movers-modal.component.html',
	styleUrls: ['./consent-movers-modal.component.scss']
})
export class ConsentMoversModalComponent {
	public modalForm: UntypedFormGroup;
	public modalMovers: UntypedFormArray;
	readonly maxSelections: number = 5;

	constructor(
		public formService: FormService,
		private dialogRef: MatDialogRef<ConsentMoversModalComponent>,
		@Inject(MAT_DIALOG_DATA) data: { moverValues: any[] }
	) {
		// Create a new FormArray for the modal
		this.modalMovers = new UntypedFormArray([]);
		
		// Create form controls from the values
		data.moverValues.forEach(value => {
			this.modalMovers.push(new UntypedFormGroup({
				checkbox: new UntypedFormControl(value.checkbox),
				_id: new UntypedFormControl(value._id),
				_name: new UntypedFormControl(value._name),
				_logo: new UntypedFormControl(value._logo),
				_rating: new UntypedFormControl(value._rating),
				_amount: new UntypedFormControl(value._amount),
				_city: new UntypedFormControl(value._city)
			}));
		});

		// Create a separate FormGroup for the modal
		this.modalForm = new UntypedFormGroup({
			movers: this.modalMovers
		});
	}

	public getSelectedCount(): number {
		return this.modalMovers.controls.filter(control => control.get('checkbox')?.value).length;
	}

	confirm() {
		// Log modal movers before sync
		const modalMoversTable = this.modalMovers.controls.map((control, index) => ({
			index,
			id: control.get('_id')?.value,
			name: control.get('_name')?.value,
			selected: control.get('checkbox')?.value ? '✓' : '✗'
		}));
		console.log('Modal Movers before sync:');
		console.table(modalMoversTable);

		// Get the consentMovers form group from the form service
		const consentMovers = this.formService.mainForm.get('consentMovers') as UntypedFormGroup;
		const moversArray = consentMovers.get('movers') as UntypedFormArray;

		// Log original movers before sync
		const originalMoversTable = moversArray.controls.map((control, index) => ({
			index,
			id: control.get('_id')?.value,
			name: control.get('_name')?.value,
			selected: control.get('checkbox')?.value ? '✓' : '✗'
		}));
		console.log('Original Movers before sync:');
		console.table(originalMoversTable);

		// Update each mover in the original form with the modal's values
		this.modalMovers.controls.forEach(modalControl => {
			const modalId = modalControl.get('_id')?.value;
			const modalSelected = modalControl.get('checkbox')?.value;

			// Find and update the corresponding mover in the original form
			for (let i = 0; i < moversArray.controls.length; i++) {
				const originalControl = moversArray.controls[i];
				if (originalControl.get('_id')?.value === modalId) {
					// Use patchValue to update the control
					originalControl.patchValue({
						checkbox: modalSelected
					}, { emitEvent: false });
					break;
				}
			}
		});

		// Log original movers after sync
		const originalMoversAfterTable = moversArray.controls.map((control, index) => ({
			index,
			id: control.get('_id')?.value,
			name: control.get('_name')?.value,
			selected: control.get('checkbox')?.value ? '✓' : '✗'
		}));
		console.log('Original Movers after sync:');
		console.table(originalMoversAfterTable);
		
		this.dialogRef.close(true);
	}

	cancel() {
		// No need to do anything with the form values on cancel
		this.dialogRef.close(false);
	}
}
